import Sos from '@mui/icons-material/Sos'
import { Alert, Button, Link, Paper, Stack, Typography } from '@mui/material'
import { api } from '../api/client'
import { useAction } from '../api/useAction'
import { useEvent } from '../events/EventContext'
import { useHelp } from './HelpContext'

const messages = {
  forbidden: "L'alerte n'est possible que pendant un de vos créneaux.",
  rate_limited: "Trop d'alertes en une heure : appelez les organisateurs.",
}

/**
 * « J'ai besoin d'aide »: one tap alerts the organizers and the volunteers of helping positions
 * on duty, the message comes after. Shown before the user's shifts too, disabled, so they know
 * where it is and when to use it.
 */
export function HelpCard() {
  const { event } = useEvent()
  const help = useHelp()
  const { error, pending, run } = useAction(messages)
  const state = help.data
  const ongoing = state?.requests.some((request) => request.mine) ?? false
  const ask = () =>
    run(async () => {
      await api.post(`/events/${event.slug}/help`, {})
      help.reload()
    })
  return (
    <Paper variant="outlined" sx={{ p: 2, borderColor: 'error.main' }}>
      <Stack spacing={1.5}>
        <Typography variant="h6" component="h2">
          Besoin d'aide ?
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Un blessé, un conflit, trop de monde à gérer, du matériel cassé : un appui suffit pour
          prévenir les organisateurs et les bénévoles de renfort en poste, qui répondent « J'y vais
          ». Vous pourrez ensuite ajouter un message.
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Urgence vitale : appelez d'abord le <Link href="tel:15">15</Link> ou le{' '}
          <Link href="tel:112">112</Link>.
        </Typography>
        <Button
          variant="contained"
          color="error"
          size="large"
          startIcon={<Sos />}
          disabled={!state?.can_request || ongoing || pending}
          onClick={ask}
          sx={{ alignSelf: 'flex-start' }}
        >
          J'ai besoin d'aide
        </Button>
        {state && !state.can_request && (
          <Typography variant="body2" color="text.secondary">
            Disponible pendant vos créneaux.
          </Typography>
        )}
        {ongoing && (
          <Typography variant="body2" color="text.secondary">
            Votre alerte est en cours, en haut de la page.
          </Typography>
        )}
        {error && <Alert severity="error">{error}</Alert>}
      </Stack>
    </Paper>
  )
}
